import { Autocomplete, MenuItem, TextField, TextFieldProps } from "@mui/material";
import { useField, useFormikContext } from "formik";
import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";

//! -------------------------------------------------------------------------------------------------- //

export interface SelectTypes {
    name: string;
    options: CountriesType[];
    [otherProps: string]: any;
}

// interface CountriesType {
//   num_code: string;
//   alpha_2_code: string;
//   alpha_3_code: string;
//   en_short_name: string;
//   nationality: string;
// }
interface CountriesType {
    id: number;
    name: { en: string; nl: string; fr: string };
    nationality?: { en: string; nl: string; fr: string };
}

// export enum CountriesTypeSelection {
//   COUNTRY = "country",
//   NATIONALITY = "nationality",
// }

const SelectWrapper = ({ name, options, ...otherProps }: SelectTypes) => {
    const locale = i18next.language === undefined ? "nl" : i18next.language;
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);
    const { t } = useTranslation();
    const distinctOptionsSet = new Set(
        options.map((value) => {
            if (value.nationality !== undefined) {
                if (locale === "en") {
                    return value.nationality.en;
                } else if (locale === "fr") {
                    return value.nationality.fr;
                } else {
                    return value.nationality.nl;
                }
            }
        })
    );
    const distinctOptions = Array.from(distinctOptionsSet).sort((a, b) => {
        if (a !== undefined && b !== undefined) {
            return a.localeCompare(b)
        } else return 0;
    });

    const handleChange = (event: any, value: string | null) => {
        event.stopPropagation()
        setFieldValue(name, value);
    };

    const selectProps: TextFieldProps = {
        ...field,
        ...otherProps,
    }

    const autoCompleteProps: any = {
        ...field,
        ...otherProps,
        options: Object.keys(distinctOptions).filter((value, index) => {
            const option = distinctOptions[index]
            if (option !== undefined) return option
        }).map((value, index) => {
            const option = distinctOptions[index];
            return option
        }),
        renderInput: (params: any) => <TextField {...params} {...selectProps} />,
        onChange: handleChange,
        fullWidth: true,
    }

    if (meta && meta.touched && meta.error) {
        selectProps.error = true;
        selectProps.helperText = t(meta.error);
    }

    return (
        <Autocomplete {...autoCompleteProps} option="" />
    );
};

export default SelectWrapper;
